import qs from 'qs';
import axios from 'axios';
import Jsona from 'jsona';

const url = process.env.VUE_APP_API_BASE_URL;
const jsona = new Jsona();

function list(params) {
  const options = {
    params: params,
    paramsSerializer: function (params) {
      return qs.stringify(params, {encode: false});
    }
  };
 
  return axios.get(`${url}/workshop/workshop_spare_part_transfers`, options)
    .then(response => {
      return {
        list: jsona.deserialize(response.data),
        meta: response.data.meta
      };
    });
}

function get(id) {
  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.get(`${url}/workshop/workshop_spare_part_transfers/${id}`, options)
    .then(response => {
      let spare_part_transfer = jsona.deserialize(response.data);
      delete spare_part_transfer.links;
      return spare_part_transfer;
    });
}

function add(spare_part_transfer) {
  
  console.log(spare_part_transfer);
  const payload = jsona.serialize({
    stuff: spare_part_transfer,
    includeNames: null
  });
  console.log(payload);
  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.post(`${url}/workshop/workshop_spare_part_transfers`, payload, options)
    .then(response => {
      return jsona.deserialize(response.data);
    });
}

function update(spare_part_transfer) {
  const payload = jsona.serialize({
    stuff: spare_part_transfer,
    includeNames: []
  });

  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.patch(`${url}/workshop/workshop_spare_part_transfers/${spare_part_transfer.id}`, payload, options)
    .then(response => {
      return jsona.deserialize(response.data);
    });
}

function update_status(spare_part_transfers) {
  const payload = jsona.serialize({
    stuff: spare_part_transfers,
    includeNames: []
  });

  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.patch(`${url}/workshop/workshop_spare_part_transfers/update_status/${spare_part_transfers.id}`, payload, options)
    .then(response => {
      return jsona.deserialize(response.data);
    });
}

function destroy(id) {
  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.delete(`${url}/workshop/workshop_spare_part_transfers/${id}`, options);
}

// function partTable() {
//   const options = {
//     headers: {
//       'Accept': 'application/vnd.api+json',
//       'Content-Type': 'application/vnd.api+json',
//     }
//   };

//   return axios.get(`${url}/workshop/workshop_spare_part_transfers/part/table`, options)
//     .then(response => {
//       //let dashboard = jsona.deserialize(response.data);
//       return response.data;
//     });
// }

function last_no() {
  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.get(`${url}/workshop/workshop_spare_part_transfers/last/no`, options)
    .then(response => {
      return response.data;
    });
}

export default {
  list,
  get,
  add,
  update,
  update_status,
  destroy,
  last_no,
  // partTable
};

